import {
  OrganizationBillingInterval,
  OrganizationBillingPlan,
  OrganizationBillingVariant,
} from "../types";

type PublicOrganizationBillingPlan = Exclude<
  OrganizationBillingPlan,
  typeof OrganizationBillingPlan.INTERNAL
>;

export const ORGANIZATION_BILLING_ALLOWANCES = {
  [OrganizationBillingPlan.STARTER]: 20,
  [OrganizationBillingPlan.PROFESSIONAL]: 75,
  [OrganizationBillingPlan.PRACTICE]: 250,
} as const satisfies Record<PublicOrganizationBillingPlan, number>;

export const organizationBillingConfig = {
  plans: [
    {
      id: OrganizationBillingPlan.STARTER,
      label: "Starter",
      annualReportAllowance:
        ORGANIZATION_BILLING_ALLOWANCES[OrganizationBillingPlan.STARTER],
      variants: [
        {
          id: OrganizationBillingVariant.STARTER_MONTHLY,
          interval: OrganizationBillingInterval.MONTHLY,
        },
        {
          id: OrganizationBillingVariant.STARTER_ANNUAL,
          interval: OrganizationBillingInterval.ANNUAL,
        },
      ],
    },
    {
      id: OrganizationBillingPlan.PROFESSIONAL,
      label: "Professional",
      annualReportAllowance:
        ORGANIZATION_BILLING_ALLOWANCES[OrganizationBillingPlan.PROFESSIONAL],
      variants: [
        {
          id: OrganizationBillingVariant.PROFESSIONAL_MONTHLY,
          interval: OrganizationBillingInterval.MONTHLY,
        },
        {
          id: OrganizationBillingVariant.PROFESSIONAL_ANNUAL,
          interval: OrganizationBillingInterval.ANNUAL,
        },
      ],
    },
    {
      id: OrganizationBillingPlan.PRACTICE,
      label: "Practice",
      annualReportAllowance:
        ORGANIZATION_BILLING_ALLOWANCES[OrganizationBillingPlan.PRACTICE],
      variants: [
        {
          id: OrganizationBillingVariant.PRACTICE_MONTHLY,
          interval: OrganizationBillingInterval.MONTHLY,
        },
        {
          id: OrganizationBillingVariant.PRACTICE_ANNUAL,
          interval: OrganizationBillingInterval.ANNUAL,
        },
      ],
    },
  ],
} as const;

export type OrganizationBillingConfig = typeof organizationBillingConfig;
export type OrganizationBillingConfigPlan =
  OrganizationBillingConfig["plans"][number];
export type OrganizationBillingConfigVariant =
  OrganizationBillingConfigPlan["variants"][number];
